<div class="main-refund-payment">
  <div class="header">
    <h3>Refund</h3>
    <app-icon class="se-icon-button" src="close" (click)="close()"></app-icon>
  </div>

  <div class="content">

    <div class="payload-row" [class.payment-error]="overAmount || empty || failedToRefund">
      <div class="payload-label">Amount</div>
      <div class="amount-field">
        <mat-form-field appearance="outline">
          <div class="d-flex">
            <div class="d-flex align-items-center mr--4">$</div>
            <input matInput
                   [formControl]="amountControl"
                   inputmode="decimal"
                   mask="separator.2" thousandSeparator="" decimalMarker="."
                   [allowNegativeNumbers]="false" [dropSpecialCharacters]="false"
                   (keydown)="decimalOnly($event)"
                   (paste)="onPaste($event)"
                   replaceCommaWithDot
            >
          </div>
          <div *ngIf="overAmount" class="payment-error">Amount exceeds payment</div>
          <div *ngIf="empty" class="payment-error">Amount is required</div>
          <div *ngIf="failedToRefund" class="payment-error">Failed to refund. Please retry later</div>
        </mat-form-field>
      </div>
    </div>

    <div class="button-section">
      <div class="button close-button" (click)="close()">Close</div>
      <loader-button class="button" [loading]="loading"
                     [text]="'Refund'" (click)="addRefund()"
      ></loader-button>
    </div>
  </div>
</div>
